import {axios} from "~/plugins/axios";

const getDefaultState_SpeechAnalysis = () => {
  return {
    call: null,
    result: [],
    questionnaires: [],
    criterials: [],
    callComments: [],
    statistic: [],
    statisticByOperators: [],
    contactForm: [],
  }
}
const state = getDefaultState_SpeechAnalysis();

const getters = {
  call: state => state.call,
  getResult: state => state.result,
  questionnaires: state => state.questionnaires,
  criterials: state => state.criterials,
  callComments: state => state.callComments,
  statistic: state => state.statistic,
  contactForm: state => state.contactForm,
}

const actions = {
  async loadTranscribeSearch({commit}, payload) {
    commit('shared/SET_LOADING', true, {root: true})
    try {
      let resp = await axios.post('/api/reports/speech-analysis/transcribe-search', payload)
      commit('shared/SET_LOADING', false, {root: true})
      this.dispatch('shared/setMeta', resp.data.meta)
      return resp.data.data

    } catch (err) {
      commit('shared/SET_ERROR', err.response.data, {root: true})
      commit('shared/SET_LOADING', false, {root: true})

      throw err
    }
  },

  async loadCalls({commit}, payload) {
    commit('shared/SET_LOADING', true, {root: true})
    try {
      let headers = {}
      if (payload.excel === true) {
        payload.to_excel = true
        headers = {
          responseType: "blob",
        }
      }

      let resp = await axios.post('/api/reports/speech-analysis/calls', payload, headers)

      if (payload.excel === true) {
        this._vm.utils.downloadXlsx(resp)
      }

      commit('shared/SET_LOADING', false, {root: true})


      this.dispatch('shared/setMeta', resp.data.meta)
      return resp.data.data

    } catch (err) {
      commit('shared/SET_ERROR', err.response.data, {root: true})
      commit('shared/SET_LOADING', false, {root: true})

      throw err
    }
  },

  async loadWiretappingRate({commit}, payload) {
    return await axios.post('/api/reports/complaints/wiretapping-rate', payload)
      .then(response => {
        this.dispatch('shared/setMeta', response.data.meta)

        return response.data.data;

      }).catch(err => {
        commit('shared/SET_ERROR', err.response.data, {root: true});

        throw err;
      });
  },

  /**
   * @param commit
   * @param {string} uid
   * @param {Object} query
   */
  async loadCall({commit}, {uid, query}) {
    commit('shared/SET_LOADING', true, {root: true});
    await axios.get('/api/reports/calls/' + uid, {params: query})
      .then(response => {
        commit('SET_CALL', response.data.data);

        if (response.data.data.comments !== undefined) {
          commit('SET_CALL_COMMENTS', response.data.data.comments);
        }

        this.dispatch('transcribe/changePhrases', response.data.data['transcribe']);
      }).catch(error => {
        commit('shared/SET_ERROR', error.response.data, {root: true});
        // commit('shared/SET_ERROR', error.response, {root: true});

        throw error;
      });

    commit('shared/SET_LOADING', false, {root: true});
  },

  async loadQuestionnaires({commit}, projectId) { // old
    commit('shared/SET_LOADING', true, {root: true});
    await axios.get(`/api/projects/${projectId}/questionnaires`)
      .then(response => {
        commit('SET_QUESTIONNAIRES', response.data);

      }).catch(error => {
        commit('shared/SET_ERROR', error.response.data, {root: true});

        throw error;
      });

    commit('shared/SET_LOADING', false, {root: true});
  },

  clearQuestionnaires({commit}) {
    commit('SET_QUESTIONNAIRES', [])
  },

  async loadCriterials({commit}, questionnaireId) {
    commit('shared/SET_LOADING', true, {root: true});
    await axios.get(`/api/questionnaires/${questionnaireId}/criterials`)
      .then(response => {
        commit('SET_CRITERIALS', response.data);

      }).catch(error => {
        commit('shared/SET_ERROR', error.response.data, {root: true});

        throw error;
      });

    commit('shared/SET_LOADING', false, {root: true});
  },

  clearCriterias({commit}) {
    commit('SET_CRITERIALS', [])
  },

  // COMPLAINTS ===========================================
  async storeComplaint({commit}, payload) { // OLD!!! 👴
    await axios.post(`/api/complaints`, payload)
      .then(response => {
        commit('shared/SET_SUCCESS', {
          message: response.data.message,
        }, {root: true});

      }).catch(error => {
        commit('shared/SET_ERROR', error.response.data, {root: true});
        commit('shared/SET_LOADING', false, {root: true});

        throw error;
      });

    commit('shared/SET_LOADING', false, {root: true});
  },

  async loadComplaints({ commit }, { uid }) {
    try {
      commit('shared/SET_LOADING', true, {root: true})

      const response = await axios.get(`/api/reports/calls/${uid}/complaints`)
      return response.data.data
    } catch (error) {
      commit('shared/SET_ERROR', error.response.data, {root: true})
      throw error
    } finally {
      commit('shared/SET_LOADING', false, {root: true})
    }
  },

  async createcomplaints({ commit }, payload) {
    try {
      commit('shared/SET_LOADING', true, {root: true})

      const response = await axios.post(`/api/operator-quality-control/complaints`, payload)
      commit('shared/SET_SUCCESS', { message: response.data.message }, {root: true})
      return response.data.data
    } catch (error) {
      commit('shared/SET_ERROR', error.response.data, {root: true})
      throw error
    } finally {
      commit('shared/SET_LOADING', false, {root: true})
    }
  },

  async loadQuestionnairesList({ commit }) {
    try {
      commit('shared/SET_LOADING', true, {root: true})

      const response = await axios.get('/api/operator-quality-control/questionnaires')
      return response.data
    } catch (error) {
      commit('shared/SET_ERROR', error.response.data, {root: true})
      throw error
    } finally {
      commit('shared/SET_LOADING', false, {root: true})
    }
  },

  async loadCriteriaList({ commit }, questionnaireId) {
    try {
      commit('shared/SET_LOADING', true, {root: true})

      const response = await axios.get(`/api/operator-quality-control/questionnaires/${questionnaireId}/criterias`)
      return response.data
    } catch (error) {
      commit('shared/SET_ERROR', error.response.data, {root: true})
      throw error
    } finally {
      commit('shared/SET_LOADING', false, {root: true})
    }
  },

  async loadQuestionnaireTypes({ commit }) {
    try {
      commit('shared/SET_LOADING', true, {root: true})

      const response = await axios.get('/api/operator-quality-control/questionnaire-types')
      return response.data
    } catch (error) {
      commit('shared/SET_ERROR', error.response.data, {root: true})
      throw error
    } finally {
      commit('shared/SET_LOADING', false, {root: true})
    }
  },

  async loadComplaint({ commit }, complaintId) {
    try {
      commit('shared/SET_LOADING', true, {root: true})

      const response = await axios.get(`/api/operator-quality-control/complaints/${complaintId}`)
      return response.data.data
    } catch (error) {
      commit('shared/SET_ERROR', error.response.data, {root: true})
      throw error
    } finally {
      commit('shared/SET_LOADING', false, {root: true})
    }
  },

  async updateComplaint({ commit }, payload) {
    const complaintId = payload.complaintId
    delete payload.complaintId

    try {
      const response = await axios.patch(`/api/operator-quality-control/complaints/${complaintId}`, payload)
      commit('shared/SET_SUCCESS', { message: response.data.message }, {root: true})
      return response
    } catch (error) {
      commit('shared/SET_ERROR', error.response.data, {root: true})
      throw error
    }
  },

  async confirmAiRate({ commit }, payload) {
    const complaintId = payload.complaintId
    delete payload.complaintId

    try {
      const response = await axios.post(`/api/operator-quality-control/complaints/${complaintId}/confirm-ai-rate`, payload)
      commit('shared/SET_SUCCESS', { message: response.data.message }, {root: true})
      return response
    } catch (error) {
      commit('shared/SET_ERROR', error.response.data, {root: true})
      throw error
    }
  },

  async destroyСomplaint({ commit }, payload) {
    const complaintId = payload.complaintId
    delete payload.complaintId

    try {
      const response = await axios.delete(`/api/operator-quality-control/complaints/${complaintId}`)
      commit('shared/SET_SUCCESS', { message: response.data.message }, {root: true})
      return response
    } catch (error) {
      commit('shared/SET_ERROR', error.response.data, {root: true})
      throw error
    }
  },


  clearCall({commit}) {
    commit('SET_CALL', null);
  },

  setResult({commit}, payload) {
    commit('ADD_RESULT', payload)
  },

  clearResult({commit}) {
    commit('CLEAR_RESULT')
  },

  async addCallComment({commit, state}, payload) {
    const uid = payload.uid

    delete payload.uid

    return axios.post(`/api/reports/calls/${uid}/comments`, payload)
      .then(response => {

        let comments = state.callComments;
        comments.unshift(response.data.data);
        commit('SET_CALL_COMMENTS', comments);
        return response;

      }).catch(error => {
        commit('shared/SET_ERROR', error.response.data, {root: true});
        commit('shared/SET_LOADING', false, {root: true});

        throw error;
      });
  },

  async deleteCallComment({commit, state}, commentId) {
    return axios.delete(`/api/reports/callsComments/${commentId}`)
      .then(response => {
        let comments = state.callComments.filter(item => item.id !== commentId);
        commit('SET_CALL_COMMENTS', comments);
        return response;

      }).catch(error => {
        commit('shared/SET_ERROR', error.response.data, {root: true});
        commit('shared/SET_LOADING', false, {root: true});

        throw error;
      });
  },

  async loadCallStatuses({commit}) {
    return axios('/api/call-statuses')
      .then(res => res.data)
      .catch(error => {
        commit('shared/SET_ERROR', error.response.data, {root: true});
      })
  },

  async loadStatistic({commit}, uid) {
    // let data = await axios(`http://gate.dev.oline/api/reports/calls/${uid}/getRatingGPT`) //[x] переключить!!!
    let data = await axios(`/api/reports/calls/${uid}/getRatingGPT`)
    .then(res => res.data)
    .catch(error => {
      commit('SET_STATISTIC', error.response.data)
    })

    if (data) {
      commit('SET_STATISTIC', data)
      return data
    }
  },

  async loadStatisticByOperators({ commit }, payload) {
    let data = await axios.post('/api/reports/complaints/statistics-on-listenners', payload)
    .then(res => res.data)
    .catch(error => {
      commit('SET_STATISTIC_BY_OPERATORS', error.response.data)
    })

    if (data) {
      commit('SET_STATISTIC_BY_OPERATORS', data)
      return data
    }
  },

  async loadStatisticRoutes({commit}) {
    try {
      let resp = await axios.get('/api/reports/speech-analysis/calls/statistics/routes')

      return resp.data
    } catch (err) {
      commit('shared/SET_ERROR', err.response.data, {root: true})

      throw err
    }
  },

  async loadStatisticPart({commit}, {name, payload}) {
    try {
      let resp = await axios.post(`/api/reports/speech-analysis/calls/statistics/${name}`, payload)

      return resp.data
    } catch (err) {
      commit('shared/SET_ERROR', err.response.data, {root: true})

      throw err
    }
  },


  // DISPUTE
  async agreedWithOperatorComment({ commit }, complaintId) {
    commit('shared/SET_LOADING', true, {root: true})

    try {
      const response = await axios.post(`/api/operator-quality-control/complaints/${complaintId}/disputes/close-in-favor-of-operator`)
      commit('shared/SET_SUCCESS', {message: response.data.message}, {root: true})
      return response.data
    } catch (error) {
      commit('shared/SET_ERROR', error.response.data, {root: true})
    } finally {
      commit('shared/SET_LOADING', false, {root: true})
    }
  },

  async disagreedWithOperatorComment({ commit }, complaintId) {
    commit('shared/SET_LOADING', true, {root: true})

    try {
      const response = await axios.post(`/api/operator-quality-control/complaints/${complaintId}/disputes/close-against-operator`)
      commit('shared/SET_SUCCESS', {message: response.data.message}, {root: true})
      return response.data
    } catch (error) {
      commit('shared/SET_ERROR', error.response.data, {root: true})
    } finally {
      commit('shared/SET_LOADING', false, {root: true})
    }
  },

  async fetchContactForm({ commit }, uid) {
    if (!uid) return;
    try {
      commit('shared/SET_LOADING', true, {root: true})
      const response = await axios.get(`/api/outbound-campaigns/contact/${uid}`);
      const fields = response.data.data.map(field => ({
        id: field.id,
        label: field.label,
        type: field.options ? 'select' : 'input',
        options: field.options || null,
        selectedOptionId: field.select_option_id,
        originalSelectedOptionId: field.select_option_id,
        value: field.value,
        originalValue: field.value,
      }));
      commit('SET_CONTACT_FORM_FIELDS', fields);
    } catch (error) {
      console.error('Ошибка загрузки анкеты:', error);
      commit('shared/SET_ERROR', error.response?.data, { root: true });
    } finally {
      commit('shared/SET_LOADING', false, {root: true})
    }
  },

  async updateContactField({ commit }, { id, data }) {
    try {
      commit('shared/SET_LOADING', true, {root: true})
      const response = await axios.patch(`/api/outbound-campaigns/filledFields/${id}`, data);
      return response.data;
    } catch (error) {
      console.error('Ошибка обновления поля анкеты:', error);
      commit('shared/SET_ERROR', error.response?.data, { root: true });
      throw error;
    } finally {
      commit('shared/SET_LOADING', false, {root: true})
    }
  },
}

const mutations = {
  SET_CALL(state, data) {
    state.call = data;
  },

  SET_CALL_COMMENTS(state, data) {
    state.callComments = data;
  },

  ADD_RESULT(state, data ) {
    state.result.push(data)
  },

  CLEAR_RESULT(state) {
    state.result = []
  },

  SET_QUESTIONNAIRES(state, data) {
    state.questionnaires = data;
  },

  SET_CRITERIALS(state, data) {
    state.criterials = data;
  },

  SET_STATISTIC(state, data) {
    state.statistic = data;
  },

  SET_STATISTIC_BY_OPERATORS(state, data) {
    state.statisticByOperators = data;
  },

  RESET_STATE_SPEECHANALYSIS (state) {
    Object.assign(state, getDefaultState_SpeechAnalysis())
  },

  SET_CONTACT_FORM_FIELDS(state, fields) {
    state.contactForm = fields;
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
